// Utilitários de cálculo de vendas (competência) com regra de cancelamento
// Regra: se cancelado no mesmo mês do fechamento => conta apenas o recebido
// Se cancelado em mês diferente => mantém valor total (não altera histórico)
// Upsell: se é um deal de upsell, subtrai o crédito para comissão

export type DealStatusForSales = 'active' | 'cancelled';

export interface DealAmountsForSales {
  deal_status?: DealStatusForSales | string | null;
  closed_date?: string | null; // geralmente YYYY-MM-DD
  cancelled_at?: string | null; // pode ser ISO ou "YYYY-MM-DD HH:mm:ss+00"
  total_amount?: number | string | null;
  amount_received?: number | string | null;
  upsell_credit_amount?: number | string | null; // valor do deal original em upsells
}

const toYearMonth = (value?: string | null): string | null => {
  if (!value) return null;
  // Aceita ISO e também "YYYY-MM-DD HH:mm:ss+00"; ambos começam com YYYY-MM
  const ym = value.slice(0, 7);
  return /^\d{4}-\d{2}$/.test(ym) ? ym : null;
};

const toNumber = (v: number | string | null | undefined): number => {
  const n = typeof v === 'string' ? Number(v) : (v ?? 0);
  return Number.isFinite(n) ? n : 0;
};

export const getDealSalesAmount = (deal: DealAmountsForSales): number => {
  const status = (deal.deal_status ?? 'active') as string;
  const totalAmount = toNumber(deal.total_amount);
  const upsellCredit = toNumber(deal.upsell_credit_amount);

  // Valor líquido para comissão = total - crédito de upsell
  const netAmount = totalAmount - upsellCredit;

  if (status !== 'cancelled') return netAmount;

  const closedYM = toYearMonth(deal.closed_date);
  const cancelledYM = toYearMonth(deal.cancelled_at);

  // Se não consigo comparar mês (falta data), por segurança mantém net (não altera histórico)
  if (!closedYM || !cancelledYM) return netAmount;

  if (closedYM === cancelledYM) {
    // Quando cancelado no mesmo mês, também subtrair o upsell credit
    return toNumber(deal.amount_received) - upsellCredit;
  }

  return netAmount;
};
